
<main>
    <nb-layout>
    <nb-layout-column>

<div *ngIf="!isAuth">
    <h3>Log in</h3>
<!-- <h2>Fake authentication!</h2>
<p *ngIf="authStatus">Vous êtes connecté !</p>
<button nbButton size="small"(click)="signIn()"  *ngIf="!authStatus">Se Connecter</button>
<button nbButton size="small"(click)="signOut()"  *ngIf="authStatus">Se Déconnecter</button> -->

    
        <form [formGroup]="fg" (ngSubmit)="onSubmit()">
            <p>Email: </p>
            <input nbInput type="text" formControlName="email">

            <p>Password: </p>
            <input nbInput  type="password" formControlName="psd">

            <button nbButton type="submit" [disabled]="fg.invalid">Log in </button>

        </form>

      
            <p>{{errorMessage}}</p>
      
</div>

<div *ngIf="isAuth">

   
        <h3>Log out</h3>
    
        <form [formGroup]="fg" (ngSubmit)="onSubmit()">
            <button nbButton type="submit">Log out</button>
        </form>
        <h3>Edit paintings</h3>
        <button (click)='toEditpage()' nbButton type="submit">Edit</button>

   
</div>



    </nb-layout-column>
     </nb-layout>
